module.exports = __webpack_public_path__ + "static/media/marker_Intersection.6861001b.svg";